// src/Pages/Occupation/EditOccupation.jsx

import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { closeModal } from '../../redux/features/modalSlice';
import { useUpdateOccupationMutation } from '../../redux/services/occupationService/occupation.Services';
import { successToast, errorToast } from '../../Utils/toast';

function EditOccupation({ data }) {
  const dispatch = useDispatch();
  const [updateOccupation, { isLoading }] = useUpdateOccupationMutation();
  
  const [formData, setFormData] = useState({
    id: '',
    occupation_name: '',
    status: 'active',
  });

  useEffect(() => {
    if (data) {
      setFormData({
        id: data.id || '',
        occupation_name: data.occupation_name || data.name || '',
        status: data.status || 'active',
      });
    }
  }, [data]);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.occupation_name.trim()) {
      errorToast('Occupation name is required');
      return;
    }

    try {
      const payload = {
        id: formData.id,
        occupation_name: formData.occupation_name,
        status: formData.status,
      };

      const response = await updateOccupation(payload).unwrap();
      successToast(response?.message || 'Occupation updated successfully');
      dispatch(closeModal());
    } catch (error) {
      console.error('Update error:', error);
      errorToast(error?.data?.message || 'Failed to update occupation');
    }
  };

  return (
    <div className="edit-occupation-container">
      <form onSubmit={handleSubmit}>
        <div className="mb-3">
          <label className="form-label fw-bold">
            Occupation Name <span className="text-danger">*</span>
          </label>
          <input
            type="text"
            className="form-control"
            name="occupation_name"
            value={formData.occupation_name}
            onChange={handleChange}
            placeholder="Enter occupation name"
            required
            autoFocus
          />
        </div>

        <div className="mb-3">
          <label className="form-label fw-bold">Status</label>
          <select
            className="form-control"
            name="status"
            value={formData.status}
            onChange={handleChange}
          >
            <option value="active">Active</option>
            <option value="inactive">Inactive</option>
          </select>
        </div>

        <div className="d-flex justify-content-end gap-2 mt-4">
          <button
            type="button"
            className="btn btn-secondary"
            onClick={() => dispatch(closeModal())}
          >
            Cancel
          </button>
          <button
            type="submit"
            className="btn btn-primary"
            disabled={isLoading}
          >
            {isLoading ? (
              <>
                <span className="spinner-border spinner-border-sm me-2" />
                Saving...
              </>
            ) : (
              'Save Changes'
            )}
          </button>
        </div>
      </form>
    </div>
  );
}

export default EditOccupation;